export default __webpack_public_path__ + "static/seventh-8bdf3d31472ff8c32ee3155dbee7b9c9.jpg";